import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { TableColumn } from '../matrisneocommon/models/table-column.model';
import { ColumnType } from '../matrisneocommon/enums/column-type.enum';
import { KnowYourColleagueService } from '../know-your-colleague/know-your-colleague.service';
import { Colleague } from '../models/ColleagueData';
import { UserProfileService } from '../services/user-profile.service';
import { MatrisToastService } from '../matrisneocommon/matris-toast.service';
import { ToastMessageSeverity } from '../enums/ToastMessageSeverity.enum';
import { AlertService } from '../services/alert.service';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent {
  blockUI:boolean = false;
  isLoading:boolean = true;
  username: string = '';
  name: string = '';
  userOrg: string = '';
  userPurchaserCode: string = '';
  title: string = '';
  showTableSkeleton: boolean = true;
  totalCount: number = 0;
  pageNumber = 0;
  pageSize = 20;
  first: number = 0;
  currentPage: number = 0;
  showCacheMessage: boolean = false;
  showPaginator: boolean = false;
  rows: any[] = [];
  columns: TableColumn[] =[
    { field: 'isSelected', header: 'Select', columnType: ColumnType.Checkbox },
    { field: 'MATERIAL_GROUP_ID', header: 'Material Group Id', columnType: ColumnType.None},
    { field: 'MATERIAL_GROUP', header: 'Mtrl Group', columnType: ColumnType.None},
    { field: 'MATERIAL_GROUP_DESCRIPTION', header: 'Description', columnType: ColumnType.None},
    { field: 'FUNCTION_NAME', header: 'Function', columnType: ColumnType.SimpleDropdown},
  ];
  selectedRows: any[] = [];
  isSaving: boolean = false;
  functionCollection: any[] =[];
  showMaterialTableSkeleton: any = null;
  materialPageNumber: number = 0;
  materialPageSize: number = 20;
  totalCountMaterial:number = 0;
  disableMaterialTable: boolean = false;
  selectedMaterialRow: any = null
  firstMaterial: number = 0;
  totalMaterial: number = 0;
  rowsMaterial: any[] = [];
  materialColumns: TableColumn[] =[
    { field: 'isSelected', header: 'Select', columnType: ColumnType.Checkbox },
    { field: 'MATERIAL_GROUP_NUMBER', header: 'Material Group No.', columnType: ColumnType.None},
    { field: 'MATERIAL_GROUP_ID', header: 'Material Group Id', columnType: ColumnType.None},
    { field: 'MATERIAL_GROUP_NAME', header: 'Description', columnType: ColumnType.None}
  ];
  materialGroupId:string = '';
  materialGroupName: string = '';
  materialGroup: string = '';
  showMaterialDialog: boolean = false;
  selectedMaterialRows: any[] = [];
  deletedRows: any[] = [];
  profileChanged: boolean = false;
  isMissingMtrlGrpId: boolean = false;
  isOldData: boolean = false;

  constructor(private location: Location, private kycService: KnowYourColleagueService, private alertService: AlertService,
    private userProfileService: UserProfileService, private messageService: MatrisToastService){}

  ngOnInit(){
    const settings = JSON.parse(localStorage.getItem('matris_user_settings') || '{}');
    const userProfile = settings?.userProfile || {};
    this.name = userProfile.name || '';
    this.username = userProfile.username || '';
    this.userOrg = userProfile.userOrg || '';
    this.userPurchaserCode = userProfile.globalPurchaserCode || '';
    this.loadUserFunctionDropdown();
  }

  goBack(){
    this.location.back();
  }

  formatName(str: string){
    const words = str.trim().split(/\s+/);

    if (words.length <= 1) {
        return str;
    }

    const [first, ...rest] = words;
    return [...rest, first].join(' ');
  }

  onTitleChange(event: any){
    this.title = event.event.target.value;
    this.profileChanged = true;
  }

  loadUserDetails(pageNumber: number = 0, pageSize: number = 20) {
    this.isMissingMtrlGrpId = false;
    this.isOldData = false;
    this.showTableSkeleton = true;
    this.isLoading = true;
    if (!this.rows.length) {
      this.rows = Array(20).fill({});
    }

    this.kycService
      .findColleagues(this.userPurchaserCode, '', '', '', '', pageNumber, pageSize, '')
      // .findColleagues('B13', '', '', '', '', pageNumber, pageSize, '')
      .subscribe({
        next: (data: any) => {
          const loadedRows  = data.data.map((item: any) => {
            const oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

            const insDate = item.INS_DATE ? new Date(item.INS_DATE) : null;
            const isOlderThanOneYear = insDate && insDate < oneYearAgo;

            let rowStyle = null;

            if (!item.MATERIAL_GROUP_ID || item.MATERIAL_GROUP_ID.toString().trim() === '') {
              rowStyle = {
                backgroundColor: '#ffe5e5',
                color: '#fe0303'
              };
              this.isMissingMtrlGrpId = true;
            }
            else if (isOlderThanOneYear) {
              rowStyle = {
                backgroundColor: '#fff3cd',
                color: '#856404'
              };
              this.isOldData = true;
            }

            return {
              ...new Colleague(item),

              FUNCTION_NAME:
                item.FUNCTION_NAME !== null &&
                item.FUNCTION_NAME !== undefined &&
                item.FUNCTION_NAME !== ''
                  ? Number(item.FUNCTION_NAME)
                  : null,

              ROW_STYLE: rowStyle,
              UI_KEY: item.MATERIAL_GROUP_ID
            };
          });
          this.rows = this.resetRowState(loadedRows);

          // this.rows.forEach(row => {
          //   row.showSimpleDropdown = true;
          //   row.FUNCTION_NAMEDropdown  = this.functionCollection;
          // });

          if (data.data?.length) {
            this.title = data.data[0].ROLE || '';
          }

          this.profileChanged = false;
          this.deletedRows = [];
          this.selectedRows = [];

          this.totalCount = data.totalCount;
          this.showPaginator = true;
          this.showTableSkeleton = false;
          this.isLoading = false;
          this.isSaving = false;
        },
        error: () => {
          this.messageService.showToast('Failed to load User Profile');
          this.showTableSkeleton = false;
          this.isLoading = false;
        }
      });
  }

  loadUserFunctionDropdown(){
    this.userProfileService.getUserFunctionDropdown().subscribe({
      next:(response: any) =>{
        this.functionCollection =[ 
          {code: '', name: ''},
          ...(response.FUNCTIONS || []).map((item: any) => ({
          code: item.CODE,
          name: item.NAME,
          }))
        ];
        this.loadUserDetails();
      },
      error:(error) =>{
        this.messageService.showToast('Failed to load Function dropdowns');
        this.loadUserDetails();
      }
    })
  }

  private resetRowState(rows: any[]): any[] {
    return rows.map(row => ({
      ...row,

      IS_NEW: false,
      IS_UPDATED: false,

      isSelected: false,

      ORIGINAL_FUNCTION_NAME: row.FUNCTION_NAME,

      showSimpleDropdown: true,
      FUNCTION_NAMEDropdown: this.functionCollection
    }));
  }


  onPageChange(event: any) {
    this.first = event.first;
    this.currentPage = event.page;
    this.pageSize = event.rows;

    this.showTableSkeleton = true;

    this.loadUserDetails(event.page, event.rows);
  }

  onProfileTableSelection(event: any): void {
    const row = event.rowData;
    const isChecked = event.event?.checked;

    row.isSelected = isChecked;

    if (isChecked) {

      const exists = this.selectedRows.some(
        x => x.UI_KEY === row.UI_KEY
      );

      if (!exists) {
        this.selectedRows.push(row);
      }

    } else {

      this.selectedRows =
        this.selectedRows.filter(
          x => x.UI_KEY !== row.UI_KEY
        );
    }
  }

  addRow(){
    this.showMaterialDialog = true;

  }

  removeRow(){
    if (this.selectedRows.length === 0) {
      return;
    }

    const rowsToDelete = this.selectedRows.filter(
      x => !x.IS_NEW
    );

    this.deletedRows = [
      ...this.deletedRows,
      ...rowsToDelete
    ];

    const selectedKeys = this.selectedRows.map(
      x => x.UI_KEY
    );

    this.rows = this.rows.filter(
      x => !selectedKeys.includes(x.UI_KEY)
    );

    this.selectedRows = [];

    this.totalCount = this.rows.length;

    this.messageService.showToast(
      ToastMessageSeverity.Success,
      'Success',
      'Selected row(s) deleted'
    );
  }

  closeMaterialDialog(){
    this.showMaterialDialog = false;
  }

  onMaterialGroupIdChange(event: any){
    this.materialGroupId = event.event.target.value;
  }

  onMaterialGroupNameChange(event: any){
    this.materialGroupName = event.event.target.value.toUpperCase();
  }

  onMaterialGroupChange(event: any){
    this.materialGroup = event.event.target.value;
  }

  handleEnter(inputType: 'materialGroup' | 'materialGroupName', event: any) {
    if (inputType == 'materialGroup') {
      this.materialGroup = event.target.value;
    } else if (inputType == 'materialGroupName' || inputType == 'purchaserCode' || inputType == 'brand') {
      this.materialGroupName = event.target.value.toUpperCase();
    }
    this.searchMaterial();
  }

  searchMaterial(){
    this.showMaterialTableSkeleton = true;
    if (!this.rowsMaterial.length) {
      this.rowsMaterial = Array(20).fill({});
    }
    this.userProfileService
    .getMaterialGroup(this.materialGroupId, this.materialGroupName, this.materialGroup, this.materialPageNumber,this.materialPageSize)
    .subscribe({
      next: (response: any) => {
        this.rowsMaterial = response.materialGroups || [];
        this.totalCountMaterial = response.count;
        this.showMaterialTableSkeleton =false;
      },
       error: () => {
                this.rowsMaterial = [];
                this.totalMaterial = 0;
                this.showMaterialTableSkeleton = false;
      
                this.messageService.showToast(
                  ToastMessageSeverity.Error,
                  'Error',
                  'Failed to load parts'
                );
              }
    })
  }

  onMaterialTableSelection(event: any){
    const row = event.rowData;
    const isChecked = event.event?.checked;

    row.isSelected = isChecked;

    if (isChecked) {
      this.selectedMaterialRows.push(row);
    } else {
      this.selectedMaterialRows =
        this.selectedMaterialRows.filter(
          x => x.MATERIAL_GROUP_ID !== row.MATERIAL_GROUP_ID
        );
    }
  }

  onMaterialPageChange(event: any) {
    this.firstMaterial = event.first;
    this.materialPageNumber = event.page;
    this.materialPageSize = event.rows;

    this.searchMaterial();
  }

  confirmMaterial() {
    if (!this.selectedMaterialRows.length) {

      this.messageService.showToast(
        ToastMessageSeverity.Warning,
        'Warning',
        'Please select a material group'
      );

      return;
    }

    const rowsToAdd: any[] = [];

    this.selectedMaterialRows.forEach(material => {

      const alreadyExists = this.rows.some(
        x => x.MATERIAL_GROUP_ID === material.MATERIAL_GROUP_ID
      );

      if (!alreadyExists) {

        rowsToAdd.push({
          MATERIAL_GROUP_ID: material.MATERIAL_GROUP_ID,
          MATERIAL_GROUP: material.MATERIAL_GROUP_NUMBER,
          MATERIAL_GROUP_DESCRIPTION: material.MATERIAL_GROUP_NAME,
          FUNCTION_NAME: '',

          showSimpleDropdown: true,
          FUNCTION_NAMEDropdown: this.functionCollection,

          IS_NEW: true,
          IS_UPDATED: false,
          isSelected: false,

          UI_KEY: material.MATERIAL_GROUP_ID
        });
      }
    });
    if (!rowsToAdd.length) {

      this.messageService.showToast(
        ToastMessageSeverity.Warning,
        'Duplicate',
        'Selected material groups already exist'
      );

      return;
    }

    this.rows = [...this.rows, ...rowsToAdd];

    this.totalCount += rowsToAdd.length;

    this.selectedMaterialRows = [];
    this.showMaterialDialog = false;

    this.messageService.showToast(
      ToastMessageSeverity.Success,
      'Success',
      'Material Group added successfully'
    );
  }

  onFunctionChange(event: any): void {
    const { field, row, event: value } = event;

    const original = row.ORIGINAL_FUNCTION_NAME ?? '';
    const current = value ?? '';

    if (original === current) {
      row[field] = value;
      row.IS_UPDATED = false;
      return;
    }

    row[field] = value;
    row.IS_UPDATED = true;

    console.log('Updated Row:', row);
  }

  getProfileChanges() {
    return {
      insertRows: this.rows.filter(x => x.IS_NEW),
      updateRows: this.rows.filter(
        x => !x.IS_NEW && x.IS_UPDATED
      ),
      deleteRows: this.deletedRows
    };
  }

  private getCurrentDate(): string {
    return new Date().toISOString().split('T')[0];
  }

  noChange() {
    const payload = {
      noChange: true,
      profile: {
        PURCHASER_CODE: this.userPurchaserCode
      },
      insertRows: [],
      updateRows: [],
      deleteRows: []
    };

    this.userProfileService.editUserProfile(this.username, payload)
      .subscribe({
        next: () => {
          this.messageService.showToast(
            ToastMessageSeverity.Success,
            'Success',
            'Profile refreshed successfully'
          );
          this.alertService.notifyProfileSaved();
          this.loadUserDetails();
        }
      });
  }

  saveProfile() {
    const changes = this.getProfileChanges();

    const hasChanges =
      changes.insertRows.length > 0 ||
      changes.updateRows.length > 0 ||
      changes.deleteRows.length > 0 ||
      this.profileChanged;

    if (!hasChanges) {
      this.noChange();
      return;
    }

    const payload = {
      profile: {
        BRAND: this.userOrg.toUpperCase(),
        PURCHASER_CODE: this.userPurchaserCode,
        ROLE: this.title,
        EMAIL: this.username,
        NAME: this.name,
        PROFILE_CHANGED: this.profileChanged
      },
      insertRows: changes.insertRows.map(row => ({
        MATERIAL_GROUP: row.MATERIAL_GROUP,
        MATERIAL_GROUP_DESCRIPTION: row.MATERIAL_GROUP_DESCRIPTION,
        INS_DATE: this.getCurrentDate(),
        MATERIAL_GROUP_ID: row.MATERIAL_GROUP_ID,
        FUNCTION_NAME: row.FUNCTION_NAME || ''
      })),

      updateRows: changes.updateRows.map(row => ({
        INS_DATE: this.getCurrentDate(),
        MATERIAL_GROUP_ID: row.MATERIAL_GROUP_ID,
        FUNCTION_NAME: row.FUNCTION_NAME || ''
      })),

      deleteRows: changes.deleteRows.map(row => ({
        MATERIAL_GROUP_ID: row.MATERIAL_GROUP_ID,
      }))
    };

    console.log(payload);

    this.userProfileService.editUserProfile(this.username, payload)
      .subscribe({
        next: () => {

          this.messageService.showToast(
            ToastMessageSeverity.Success,
            'Success',
            'User Profile saved successfully'
          );
          this.alertService.notifyProfileSaved();
          this.loadUserDetails();

          this.isSaving = false;
        },
        error: () => {

          this.isSaving = false;

          this.messageService.showToast(
            ToastMessageSeverity.Error,
            'Error',
            'Failed to save User Profile'
          );
        }
      });
  }

}
